<template>
    <div>
        <div class="product-card"
         v-for="p in ProductObject"   :key="p.id "
        >
        <div class='productImageContainer'>
            <img :src="p.img"  class="rounded img-sm">
        </div>

        <div class="productDetails">
            <div class="productTitle">{{p.descricao}}</div>
            <div class="priceContainer">
                <div class="priceText">R$ {{p.price}}</div>
            </div>
            <div class="productEditQuantity">
                <button v-show='p.quantity == 1' class="btn" type="button"> </button>
                <button v-show='p.quantity > 1' class="btn" type="button" @click='alterQuantity({"quantity":-1,"price":p.price,"product":p.product,"user":p.user})'> <i class="fa fa-minus"></i> </button>
                <div id="product-amount">{{p.quantity}}</div>
               <button class="btn" type="button" @click='alterQuantity({"quantity":1,"price":p.price,"product":p.product,"user":p.user})'> <i class="fa fa-plus"></i> </button>
            </div>
        </div>
        <svg viewBox="0 0 24 24" @click='removeToCart(p.id)' role="presentation" id="product-delete-button" class="css-xafw2q" style="width: 24px; height: 24px;"><path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" style="fill: rgb(153, 153, 153);"></path></svg>
        </div>

    </div>
</template>

<script>

    export default {
        methods: {

        },
        computed: {
        userLocalId (){
            return localStorage.getItem('id_user');
        },
        },
        data() {
            return {
                parts: {},
            }
        },
        props: {
            ProductObject: {
                type: [Array,Number,Object],
            },
            alterQuantity: {
                type:Function
            },
            removeToCart: {
                type:Function
            },

        },
    }
</script>

<style lang="css" scoped>
@import '../../assets/css/mobile.css';

.productEditQuantity {
    height: 2.5rem;
    padding: .5rem;
    display: flex;
    font-size: 0.875rem;
    font-weight: 400;
    border-radius:  0.875rem;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    border: 1px solid rgb(230, 230, 230);
    color: rgb(153, 153, 153);
    margin-top:  0.875rem;
    user-select: none;
    max-width: 15.625rem;
}


.product-card {
    display: flex;
    flex-flow: row;
    position: relative;
    width: 100%;
    border-radius: 0.5rem;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);
    border: .1rem solid var(--main-red-light);
    box-shadow: rgb(0 0 0 / 8%) 0px 2px 4px 0px;
    font-size: 0.875rem;
    text-align: left;
    height: 9.5rem;
    margin-top:2%;

}


.productImageContainer {
    height: 5.5rem;
    display: flex;
    margin: 1rem;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}

.productImage {
    height: 55rem;
    align-self: center;
    padding: 4px;
}

.productDetails {
    padding: 0.875rem;
    display: flex;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex-grow: 1;
    -webkit-box-pack: justify;
    justify-content: space-between;
}

.priceContainer {
    display: flex;
    margin-top: 0.875rem;
}
.productTitle {
    text-align: left;
    color: var(--main-black);
    overflow: hidden;
    display: -webkit-box;
    line-height: 1rem;
    max-height: 2rem;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}


.priceText {
    font-weight: 500;
    color: rgb(51, 51, 51);
}

.btn-red-black {
    color: var(--main-white);;
    background-color:var(--main-red-black);
    border-color: #fff0e5;
}
.btn-red {
    color: var(--main-red-black);
}

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.9rem + 2px);
    padding: 0.45rem 0.85rem;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: var(--main-black);
    background-color:var(--main-red-light);
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.37rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.img-sm {
    width: 50px;
    height: 50px;
}


.title-red {
  font-size: 1.25rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.price {
    font-weight: 900;
    color: #212529;
}

.btn-red-trash {
    color: var(--main-red-black);
    background-color:var(--main-white);
    border-color:var(--main-red-black);
}

  @media (min-width: 1400px) and (max-width: 2600px) {

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.9rem + 2px);
    padding: 0.45rem 0.85rem;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: var(--main-black);
    background-color:var(--main-red-light);
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.37rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.img-sm {
    width: 112px;
    height: 112px;
}
  }

</style>